<template>
  <div class="flex flex-col gap-2.5">
    <a
      v-for="link in links"
      :key="link.key"
      :href="link.href"
      target="_blank"
      class="glass-tile relative flex items-center gap-4 rounded-xl p-4 pr-14 no-underline transition-shadow hover:shadow-md"
    >
      <lazy-image :src="link.image" replace-color class="size-15.5 shrink-0 rounded-lg shadow-[0_0_10px_0_#00000033]" />

      <span class="flex max-w-150 flex-col gap-0.5 text-sm text-foreground">
        <span class="font-extrabold">{{ link.title }}</span>
        {{ link.description }}
      </span>

      <span aria-hidden="true" class="glass-button absolute top-1/2 right-4 flex size-8 -translate-y-1/2 items-center justify-center rounded-full text-primary max-sm:top-auto max-sm:bottom-3.5 max-sm:translate-y-0">
        <chevron-right-icon class="size-4" />
      </span>
    </a>
  </div>
</template>

<script>
import { ChevronRight } from '@lucide/vue';

import consultationImage from '@/assets/img/help-links/consultation.png';
import featureUpdatesImage from '@/assets/img/help-links/feature-updates.png';
import userManualImage from '@/assets/img/help-links/user-manual.png';
import videosImage from '@/assets/img/help-links/videos.png';
import LazyImage from '@/ui/components/LazyImage.vue';

/** Help and learning links shown while the automation list is empty. */
export default {
  name: 'HelpLinks',
  components: {
    ChevronRightIcon: ChevronRight,
    LazyImage,
  },
  computed: {
    isHungarian() {
      return this.$root.language === 'hu';
    },
    userManualLink() {
      const baseUrl = 'https://docs.infinite.tools';
      const languagePath = this.$root.language !== 'en' ? '/' + this.$root.language : '';

      if (this.$app.isShoprenterApp) {
        return baseUrl + '/shoprenter' + languagePath;
      }

      return baseUrl + languagePath + '/ad';
    },
    links() {
      return [
        {
          key: 'videos',
          image: videosImage,
          href: this.isHungarian ? 'https://infinite.ad/videotar/' : 'https://infinite.ad/en/videotar/',
          title: this.tr('Video tutorials'),
          description: this.tr('Learn how to maximize your social media advertising with step-by-step guides. Discover how :app can revolutionize your campaigns in minutes.'),
        },
        {
          key: 'feature-updates',
          image: featureUpdatesImage,
          href: this.isHungarian ? 'https://infinite.tools/hu/blog/' : 'https://infinite.tools/blog/',
          title: this.tr('Feature updates'),
          description: this.tr('Stay ahead with our latest AI innovations. Explore new tools and enhancements designed to boost your advertising performance.'),
        },
        {
          key: 'user-manual',
          image: userManualImage,
          href: this.userManualLink,
          title: this.tr('User manual'),
          description: this.tr('Access comprehensive resources to master :app. Find answers, best practices, and strategies to optimize your social media advertising.'),
        },
        {
          key: 'consultation',
          image: consultationImage,
          href: this.isHungarian
            ? 'https://calendly.com/d/cq6q-x25-7cr/infinite-ad-social-hirdetes-tanacsadas'
            : 'https://calendly.com/d/cnvz-wxw-9fp/infinite-ad-social-advertising-consultation',
          title: this.tr('Strategic Consultation'),
          description: this.tr('Elevate your advertising with expert strategic guidance. Our specialists will help you develop customized :app campaigns aligned with your business goals.'),
        },
      ];
    },
  },
};
</script>
